<template>
  <el-dialog title="Advance Search" :visible="dialogVisible" @close="closeDl" width="1200px">
    <el-form class="search-form" label-width="150px" style="display:flex; flex-direction: column">
      <div class="search-group" style="width: 100%">
        <el-form-item label="Composition">
          <!--            <el-autocomplete style="width: 140px"-->
          <!--                             placeholder="please input "-->
          <!--                             v-model="compositionInput"-->
          <!--                             :fetch-suggestions="compositionSearchAsync"-->
          <!--                             @select="handleSelect"-->
          <!--                             @keydown.enter.native="handleIconClick">-->
          <!--            </el-autocomplete>-->
          <el-select v-model="compositionInput" style="width: 140px"  filterable allow-create placeholder="input or select">
            <el-option
              v-for="item in compositions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Weight">
          <el-select v-model="weightInput" style="width: 140px"  filterable allow-create placeholder="input or select">
            <el-option
              v-for="item in weights"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="search-group" style="width: 100%">
        <el-form-item label="Warp Yarn Count">
          <el-select v-model="warpYarnCountInput" style="width: 140px"  filterable allow-create placeholder="input or select">
            <el-option
              v-for="item in warpYarnCounts"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Weft Yarn Count">
          <el-select v-model="weftYarnCountInput" style="width: 140px"  filterable allow-create placeholder="input or select">
            <el-option
              v-for="item in weftYarnCounts"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Warp Density">
          <el-select v-model="warpDensityInput" style="width: 140px"  filterable allow-create placeholder="input or select">
            <el-option
              v-for="item in warpDensitys"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Weft Density">
          <el-select v-model="weftDensityInput" style="width: 140px"  filterable allow-create placeholder="input or select">
            <el-option
              v-for="item in weftDensitys"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="search-group" style="width: 100%">
        <el-form-item label="Product Type">
          <el-select v-model="productTypeInput" style="width: 140px"  filterable allow-create placeholder="input or select">
            <el-option
              v-for="item in productTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Technology">
          <el-select v-model="technologyInput" style="width: 140px"  filterable allow-create placeholder="input or select">
            <el-option
              v-for="item in technologys"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Pattren">
          <el-select v-model="pattrenInput" style="width: 140px"  filterable allow-create placeholder="input or select">
            <el-option
              v-for="item in pattrens"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Style">
          <el-select v-model="styleInput" style="width: 140px"  filterable allow-create placeholder="input or select">
            <el-option
              v-for="item in styles"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="search-group" style="width: 100%">
        <el-form-item label="Finish">
          <el-select v-model="finishInput" style="width: 140px"  filterable allow-create placeholder="input or select">
            <el-option
              v-for="item in finishs"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Color">
          <el-select v-model="colorInput" style="width: 140px"  filterable allow-create placeholder="input or select">
            <el-option
              v-for="item in colors"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Fabric Type">
          <el-select v-model="fabricTypeInput" style="width: 140px"  filterable allow-create placeholder="input or select">
            <el-option
              v-for="item in fabricTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

      </div>

    </el-form>
    <div slot="footer" class="dialog-footer" style="display: flex; flex-direction: row; justify-content: right">
      <y-button :classStyle=" 'main-btn' "
                style="width: 130px;height: 40px;line-height: 40px;font-size: 16px"
                :text="Search" @btnClick="handleAdvanceSearchClick()">
      </y-button>
      <y-button :classStyle=" 'main-btn' "
                style="margin-left: 20px; width: 130px;height: 40px;line-height: 40px;font-size: 16px"
                :text="Reset" @btnClick="resetDialog()"></y-button>
      <!--        <y-button :classStyle=" 'main-btn' "-->
      <!--                  style="margin-left: 20px; width: 130px;height: 40px;line-height: 40px;font-size: 16px"-->
      <!--                  :text="Close" @btnClick="closeDialog()"></y-button>-->
    </div>
  </el-dialog>
</template>
<script>

import YButton from '/components/YButton'
import {navList} from '/api/index'
import {picSearch, getQuickSearch} from '/api/goods'

export default {
  props: {
    showheader: true,
    dialogVisible: false
  },
  data: function () {
    return {
      showDialog: false,
      error: false,
      choosePage: -1,
      banner: [],
      mark: 0,
      home: [],
      loading: true,
      notify: '1',
      timer: '',
      navList: [],
      headerObj: {},
      showAdvance: false,
      Search: 'AdvanceSearch',
      Close: 'Close',
      Reset: 'Reset',
      searchType: '',
      input: '',
      compositionInput: '',
      warpYarnCountInput: '',
      weftYarnCountInput: '',
      warpDensityInput: '',
      weftDensityInput: '',
      productTypeInput: '',
      technologyInput: '',
      pattrenInput: '',
      styleInput: '',
      finishInput: '',
      colorInput: '',
      fabricTypeInput: '',
      weightInput: '',
      compositions: [],
      compValue: '',
      weights: [],
      weightValue: '',
      warpYarnCounts: [],
      warpYarnCountValue: '',
      warpDensitys: [],
      warpDensityValue: '',
      weftYarnCounts: [],
      weftYarnCountValue: '',
      weftDensitys: [],
      weftDensityValue: '',
      productTypes: [],
      productTypeValue: '',
      technologys: [],
      technologyValue: '',
      styles: [],
      styleValue: '',
      finishs: [],
      finishValue: '',
      colors: [],
      colorValue: '',
      fabricTypes: [],
      fabricTypeValue: '',
      pattrens: [],
      pattrenValue: ''
    }
  },
  methods: {
    linkTo (item) {
      if (item.type === 0 || item.type === 2) {
        // 关联商品
        this.$router.push({
          path: '/goodsDetails',
          query: {
            productId: item.productId
          }
        })
      } else {
        // 完整链接
        window.location.href = item.fullUrl
      }
    },
    handleIconClick () {
      if (this.input === '') {
      } else {
        this.$router.push({
          path: '/goods?r=' + Math.random() + '&cid=' + encodeURIComponent(this.input)
        })
      }
    },
    handleAdvanceSearchClick () {
      let queryStr = ''
      // if (this.compositionInput !== '') {
      // constituent
      queryStr += this.compositionInput + ' @'
      // }
      // if (this.weightInput !== '') {
      // grammage
      queryStr += this.weightInput + ' @'
      // }
      // if (this.warpYarnCountInput !== '') {
      // radial_yarn_count
      queryStr += this.warpYarnCountInput + ' @'
      // }
      // if (this.warpDensityInput !== '') {
      // radial_density
      queryStr += this.warpDensityInput + ' @'
      // }
      // if (this.weftYarnCountInput !== '') {
      // weft_yarn_count
      queryStr += this.weftYarnCountInput + ' @'
      // }
      // if (this.weftDensityInput !== '') {
      // weft_density
      queryStr += this.weftDensityInput + ' @'
      // }
      // if (this.productTypeInput !== '') {
      // type
      queryStr += this.productTypeInput + ' @'
      // }

      // if (this.technologyInput !== '') {
      // technology
      queryStr += this.technologyInput + ' @'
      // }
      // if (this.pattrenInput !== '') {
      // pattern
      queryStr += this.pattrenInput + ' @'
      // }
      // if (this.styleInput !== '') {
      // supply_type
      queryStr += this.styleInput + ' @'
      // }
      // if (this.finishInput !== '') {
      // tidy_way
      queryStr += this.finishInput + ' @'
      // }
      // if (this.colorInput !== '') {
      // color
      queryStr += this.colorInput + ' @'
      // }
      // if (this.fabricTypeInput !== '') {
      // fabric_position
      queryStr += this.fabricTypeInput + ' @'
      // }
      if (queryStr === '') {
      } else {
        // window.open('//' + window.location.host + '/#/goodSearch?r=' + Math.random() + '&advcid=' + encodeURIComponent(queryStr))
        //
        // this.$router.push({
        //   path: '/goods?r=' + Math.random() + '&advcid=' + encodeURIComponent(queryStr)
        // })
        let myurl = '/goodSearch?r=' + Math.random() + '&advcid=' + encodeURIComponent(queryStr)
        this.$emit('openLink', myurl)
        this.closeDl()
      }
    },
    handleBeforeUpload (file) {
      let fileData = new FormData()
      fileData.append('file', file)
      fileData.append('pn', 0)
      fileData.append('rn', 20)
      picSearch(fileData)
        .then((res) => {
          let products = res.data.briefs.map(item => {
            return item.productId
          })
          products = (products.join(','))
          this.$router.push({path: '/goods?r=' + Math.random() + '&products=' + products})
        })
    },
    handleSearch () {
      this.loadOptions('composition')
      this.loadOptions('weight')
      this.loadOptions('warpYarnCount')
      this.loadOptions('weftYarnCount')
      this.loadOptions('warpDensity')
      this.loadOptions('weftDensity')
      this.loadOptions('productType')
      this.loadOptions('technology')
      this.loadOptions('pattren')
      this.loadOptions('finish')
      this.loadOptions('color')
      this.loadOptions('fabricType')
      this.loadOptions('style')
    },
    _getNavList () {
      navList().then(res => {
        this.navList = res.result
      })
    },
    // 导航栏文字样式改变
    changePage (v) {
      this.choosePage = v
    },
    changGoods (v, item) {
      this.changePage(v)
      if (v === -1) {
        this.$router.push({
          path: '/'
        })
      } else if (v === -2) {
        this.$router.push({
          path: '/refreshgoods'
        })
      } else {
        // 站内跳转
        if (item.type === 1) {
          window.location.href = item.fullUrl
        } else {
          // 站外跳转
          window.open(item.fullUrl)
        }
      }
    },
    // 搜索框提示
    loadAll (keyinput) {
      let params = {
        params: {
          key: keyinput,
          sType: this.searchType
        }
      }
      getQuickSearch(params).then(res => {
        if (res === null || res === '') {
          return
        }
        // if (res.error) {
        //   this.showError(res.error.reason)
        //   return
        // }
        var array = []
        var maxSize = 10
        if (res.length <= 10) {
          maxSize = res.length
        }
        for (var i = 0; i < maxSize; i++) {
          var obj = {}
          obj.value = res[i]
          array.push(obj)
        }
        if (array.length !== 0) {
          this.searchResults = array
        } else {
          this.searchResults = []
        }
      })
    },
    loadOptions (oType) {
      let params = {
        params: {
          key: '',
          sType: oType
        }
      }
      getQuickSearch(params).then(res => {
        if (res === null || res === '') {
          return
        }
        var array = []
        // var maxSize = 10
        // if (res.length <= 10) {
        //   maxSize = res.length
        // }
        for (var i = 0; i < res.length; i++) {
          var obj = {}
          obj.value = res[i]
          obj.label = res[i]
          array.push(obj)
        }
        switch (oType) {
          case 'weftYarnCount' :
            this.weftYarnCounts = array
            break
          case 'composition' :
            this.compositions = array
            break
          case 'weight' :
            this.weights = array
            break
          case 'warpYarnCount' :
            this.warpYarnCounts = array
            break
          case 'warpDensity' :
            this.warpDensitys = array
            break
          case 'weftDensity' :
            this.weftDensitys = array
            break
          case 'productType' :
            this.productTypes = array
            break
          case 'technology' :
            this.technologys = array
            break
          case 'pattren' :
            this.pattrens = array
            break
          case 'finish' :
            this.finishs = array
            break
          case 'color' :
            this.colors = array
            break
          case 'fabricType' :
            this.fabricTypes = array
            break
          case 'style' :
            this.styles = array
            break
        }
        // if (array.length !== 0) {
        //   this.compositions = array
        // } else {
        //   this.compositions = []
        // }
      })
    },
    querySearchAsync (queryString, cb) {
      this.searchType = ''
      // this.input = queryString
      if (this.input === undefined) {
        cb([])
        return
      }
      this.input = this.input.trim()
      if (this.input === '') {
        cb([])
        return
      } else {
        this.loadAll(this.input)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    compositionSearchAsync (queryString, cb) {
      this.searchType = 'composition'
      if (this.compositionInput === undefined) {
        cb([])
        return
      }
      this.compositionInput = this.compositionInput.trim()
      if (this.compositionInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.compositionInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    weightSearchAsync (queryString, cb) {
      this.searchType = 'weight'
      if (this.weightInput === undefined) {
        cb([])
        return
      }
      this.weightInput = this.weightInput.trim()
      if (this.weightInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.weightInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    warpYarnCountSearchAsync (queryString, cb) {
      this.searchType = 'warpYarnCount'
      if (this.warpYarnCountInput === undefined) {
        cb([])
        return
      }
      this.warpYarnCountInput = this.warpYarnCountInput.trim()
      if (this.warpYarnCountInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.warpYarnCountInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    weftYarnCountSearchAsync (queryString, cb) {
      this.searchType = 'weftYarnCount'
      if (this.weftYarnCountInput === undefined) {
        cb([])
        return
      }
      this.weftYarnCountInput = this.weftYarnCountInput.trim()
      if (this.weftYarnCountInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.weftYarnCountInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    warpDensitySearchAsync (queryString, cb) {
      this.searchType = 'warpDensity'
      if (this.warpDensityInput === undefined) {
        cb([])
        return
      }
      this.warpDensityInput = this.warpDensityInput.trim()
      if (this.warpDensityInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.warpDensityInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    weftDensitySearchAsync (queryString, cb) {
      this.searchType = 'weftDensity'
      if (this.weftDensityInput === undefined) {
        cb([])
        return
      }
      this.weftDensityInput = this.weftDensityInput.trim()
      if (this.weftDensityInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.weftDensityInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    productTypeSearchAsync (queryString, cb) {
      this.searchType = 'productType'
      if (this.productTypeInput === undefined) {
        cb([])
        return
      }
      this.productTypeInput = this.productTypeInput.trim()
      if (this.productTypeInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.productTypeInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    technologySearchAsync (queryString, cb) {
      this.searchType = 'technology'
      if (this.technologyInput === undefined) {
        cb([])
        return
      }
      this.technologyInput = this.technologyInput.trim()
      if (this.technologyInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.technologyInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    pattrenSearchAsync (queryString, cb) {
      this.searchType = 'pattren'
      if (this.pattrenInput === undefined) {
        cb([])
        return
      }
      this.pattrenInput = this.pattrenInput.trim()
      if (this.pattrenInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.pattrenInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    finishSearchAsync (queryString, cb) {
      this.searchType = 'finish'
      if (this.finishInput === undefined) {
        cb([])
        return
      }
      this.finishInput = this.finishInput.trim()
      if (this.finishInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.finishInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    colorSearchAsync (queryString, cb) {
      this.searchType = 'color'
      if (this.colorInput === undefined) {
        cb([])
        return
      }
      this.colorInput = this.colorInput.trim()
      if (this.colorInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.colorInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    fabricTypeSearchAsync (queryString, cb) {
      this.searchType = 'fabricType'
      if (this.fabricTypeInput === undefined) {
        cb([])
        return
      }
      this.fabricTypeInput = this.fabricTypeInput.trim()
      if (this.fabricTypeInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.fabricTypeInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    styleSearchAsync (queryString, cb) {
      this.searchType = 'style'
      if (this.styleInput === undefined) {
        cb([])
        return
      }
      this.styleInput = this.styleInput.trim()
      if (this.styleInput === '') {
        cb([])
        return
      } else {
        this.loadAll(this.styleInput)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    handleSelect (item) {
      this.input = item.value
    },
    closeDialog () {
      this.dialogVisible = false
    },
    resetDialog () {
      this.compositionInput = ''
      this.weightInput = ''
      this.warpDensityInput = ''
      this.warpYarnCountInput = ''
      this.weftYarnCountInput = ''
      this.weftDensityInput = ''
      this.productTypeInput = ''
      this.technologyInput = ''
      this.pattrenInput = ''
      this.styleInput = ''
      this.finishInput = ''
      this.colorInput = ''
      this.fabricTypeInput = ''
    },
    mounted () {
      this._getNavList()

      // this.showAdvance = true
    },
    closeDl () {
      this.$emit('closeDialog')
    }
  },
  created () {
    // this.$emit('setShowHeader', false)
    // this.loadOptions('')
    this.dialogVisible = false
    this.showDialog = false
    this.handleSearch()
  },

  components: {
    // YShelf,
    // product,
    YButton
  }
}
</script>
<style lang="scss">
.home {
  display: block;
  flex-direction: column;
  background: white;
  height: 100%;
}

.no-info {
  padding: 100px 0;
  text-align: center;
  font-size: 30px;
  display: flex;
  flex-direction: column;

  .no-data {
    align-self: center;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.page {
  position: absolute;
  width: 100%;
  top: 470px;
  z-index: 30;

  .dots {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .dot-active {
      display: inline-block;
      width: 15px;
      height: 15px;
      background-color: whitesmoke;
      border-radius: 8px;
      margin-right: 10px;
      cursor: pointer;
    }

    .dot {
      opacity: 0.2;
    }
  }
}

.activity-panel {
  width: 1220px;
  margin: 0 auto;

  .box {
    overflow: hidden;
    position: relative;
    z-index: 0;
    margin-top: 25px;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, .14);
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 3px 8px -6px rgba(0, 0, 0, .1);
  }

  .content {
    float: left;
    position: relative;
    box-sizing: border-box;
    width: 25%;
    height: 200px;
    text-align: center;
  }

  .content ::before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    box-sizing: border-box;
    border-left: 1px solid #f2f2f2;
    border-left: 1px solid rgba(0, 0, 0, .1);
    width: 100%;
    height: 100%;
    content: "";
    pointer-events: none;
  }

  .i {
    width: 305px;
    height: 200px;
  }

  .cover-link {
    cursor: pointer;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 4;
    background: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat;
  }

  a {
    color: #5079d9;
    cursor: pointer;
    transition: all .15s ease-out;
    text-decoration: none;
  }

  a:hover {
    box-shadow: inset 0 0 38px rgba(0, 0, 0, .08);
    transition: all .15s ease;
  }
}

.search-button-area {
  margin-top: 100px;
  height: 50px;
  text-align: center;
  //width: 400px;
  //background-color: #82848a;
  display: flex;
  flex-direction: row;
}

.search-button-area1 {
  align-items: center;
  alignment: center;
  align-self: center;
  align-content: center;
  margin-top: 10px;
  height: 50px;
  //width: 400px;
  //background-color: #82848a;
  display: flex;
  flex-direction: row;
}

.nav-sub {
  position: fixed;
  width: 100%;
  z-index: 20;
  height: 90px;
  background: #f7f7f7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .04);
  top: 100px;

  &.fixed {
    position: fixed;
    z-index: 21;
    height: 60px;
    top: 100px;
    left: 0;
    right: 0;
    border-bottom: 1px solid #dadada;
    background-image: -webkit-linear-gradient(#fff, #f1f1f1);
    background-image: linear-gradient(#fff, #f1f1f1);
  }

  .nav-sub-wrapper {
    padding: 31px 0;
    height: 90px;
    position: relative;

    &.fixed {
      padding: 0;
      height: 100%;
      display: flex;
      align-items: center;
    }

    &:after {
      content: " ";
      position: absolute;
      top: 89px;
      left: 50%;
      margin-left: -610px;
      width: 1220px;
      background: #000;
      height: 1px;
      display: none;
      opacity: 0;
      -webkit-transition: opacity .3s ease-in;
      transition: opacity .3s ease-in;
    }
  }

  .w {
    display: flex;
    justify-content: space-between;
  }

  .nav-list2 {
    height: 28px;
    line-height: 28px;
    display: flex;
    align-items: center;
    height: 100%;

    li:first-child {
      padding-left: 0;

      a {
        padding-left: 10px;
      }
    }

    li {
      position: relative;
      float: left;
      padding-left: 2px;

      a {
        display: block;
        padding: 0 10px;
        color: #666;

        &.active {
          font-weight: bold;
        }
      }

      a:hover {
        color: #5683EA;
      }
    }

    li:before {
      content: ' ';
      position: absolute;
      left: 0;
      top: 13px;
      width: 2px;
      height: 2px;
      background: #bdbdbd;
    }
  }
}

.queryParam {
  width: 200px;
  //margin-left: 80px;
  margin-top: 10px;

}

.image_search {
  display: flex;
  align-items: center;
  alignment: center;
  //position: absolute;
  margin-left: 10px;
}

.btSearch {
  margin-left: 50%;
  width: 160px;
  height: 50px
}

//.advance-search {
//  position: absolute;
//  z-index: 10;
//  padding-top: 900px;
//  //opacity: 0.9;
//  display: flex;
//  flex-direction: column;
//  background-color: rgba(150,150,150,0.8);
//
//  width: 100%;
//  height: 200%;
//
//  //visibility: hidden;
//}

//.QueryDialog {
//  //width: 100%;
//  //background-color: gray;
//  display: flex;
//  margin: 0 auto;
//  flex-direction: row;
//}

.logoss {
  text-align-all: center;
  margin-top: 200px;
  margin-left: 40%;
  //background-color;
}

.welcome {
  text-align: center;
  font-size: 18px;
  color: #8cc5ff
}

.search-group {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// advanceSearch-backup20230629.vue?6a6ef8ae